import { i18n } from '@/i18n/i18n'
import { parseDateString, format } from '../moment'

export const dateHigherThan = {
  message (field, args) {
    const includeEqual = args[1]
    const formattedDate = format(args[0], i18n.t('format.date'))

    return includeEqual ? i18n.t('validation.dateHigherEqualThan', { date: formattedDate, field })
      : i18n.t('validation.dateHigherThan', { date: formattedDate, field })
  },
  validate (value, [date, includeEqual = false]) {
    if (value === null || value === undefined || value === '') {
      return true
    }

    const date1 = parseDateString(value)
    const date2 = parseDateString(date)
    return !!(date1 && date2 && (includeEqual ? (date1 >= date2) : (date1 > date2)))
  }
}

export const dateLowerThan = {
  message (field, args) {
    const includeEqual = args[1]
    const formattedDate = format(args[0], i18n.t('format.date'))

    return includeEqual ? i18n.t('validation.dateLowerEqualThan', { date: formattedDate, field })
      : i18n.t('validation.dateLowerThan', { date: formattedDate, field })
  },
  validate (value, [date, includeEqual = false]) {
    if (value === null || value === undefined || value === '') {
      return true
    }

    const date1 = parseDateString(value)
    const date2 = parseDateString(date)
    return !!(date1 && date2 && (includeEqual ? (date1 <= date2) : (date1 < date2)))
  }
}
